import { RootState } from '@app/model';

export const selectActiveInvites = ({ invite: { activeInvites } }: RootState) => activeInvites;
